import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import s from './InspectionPurpose.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';

const InspectionPurposeListTable = ({
  InspectionPurposeData,
  RemoveInspectionPurpose,
  ChangeInspectionPurpose,
  UpdateAllowed,
  DeleteAllowed,
  intl
}) => {
  return (
    <div>
      <Table variant className={s.innerTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="common.title" defaultMessage="Title" />
            </th>
            <th>
              <FormattedMessage id="common.description" defaultMessage="Description" />
            </th>
            {(UpdateAllowed || DeleteAllowed) && <th></th>}
          </tr>
        </thead>
        <tbody>
          {InspectionPurposeData.map(n => {
            return (
              <Fragment key={n.InspectionPurposeId}>
                <tr data-unittest="inspectionPurposeData">
                  <td>{n.Name}</td>
                  <td>{n.Description}</td>
                  {(UpdateAllowed || DeleteAllowed) && (
                    <td className={s.btnCol}>
                      {UpdateAllowed && (
                        <Button
                          variant="outline-secondary"
                          className={s.changeButton}
                          href="#"
                          onClick={() => {
                            ChangeInspectionPurpose(n.InspectionPurposeId);
                          }}
                          data-unittest="changeData"
                        >
                          <FormattedMessage id="common.change" defaultMessage="CHANGE" />
                        </Button>
                      )}
                      {DeleteAllowed && (
                        <Button
                          variant="outline-secondary"
                          className={s.removeButton}
                          href="#"
                          onClick={() => {
                            RemoveInspectionPurpose(n.InspectionPurposeId);
                          }}
                          data-unittest="removeData"
                        >
                          <FormattedMessage id="common.remove" defaultMessage="REMOVE" />
                        </Button>
                      )}
                    </td>
                  )}
                </tr>
              </Fragment>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

InspectionPurposeListTable.defaultProps = {
  InspectionPurposeData: []
};

InspectionPurposeListTable.propTypes = {
  InspectionPurposeData: PropTypes.array.isRequired,
  RemoveInspectionPurpose: PropTypes.func.isRequired,
  ChangeInspectionPurpose: PropTypes.func.isRequired,
  UpdateAllowed: PropTypes.bool,
  DeleteAllowed: PropTypes.bool
};

export default injectIntl(InspectionPurposeListTable);
